import { IReferrer } from '../entities/IReferrer';
import { ReferrerKindEnum } from '../enums/ReferrerKindEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateReferrerParams {
  name: string;
  kind?: ReferrerKindEnum;
  phone?: string | null;
  instagram?: string | null;
}

export interface IUpdateReferrerParams {
  name?: string;
  kind?: ReferrerKindEnum;
  phone?: string | null;
  instagram?: string | null;
}

class ReferrerService {
  private _baseURL = 'referrers';

  getAll(): Promise<IReferrer[]> {
    return httpClient.get<null, IReferrer[]>(this._baseURL);
  }

  create(data: ICreateReferrerParams): Promise<IReferrer> {
    return httpClient.post<null, IReferrer>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateReferrerParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new ReferrerService();
